/* eslint-disable no-underscore-dangle */
import FormioUtils from 'formiojs/utils';
import { customComponents } from 'hes-formio-components';

const RefreshComponent = (customComponents as any).refreshComponent;

class FetchComponent extends (RefreshComponent as any) {
    checkRequestCondition() {
        return FormioUtils.checkCustomConditional(
            this.component,
            this?.component?.customRequestConditional,
            this.data,
            this.rootValue,
            this.root ? this.root._form : {},
            'request',
            true,
            this,
        );
    }

    async fetchData() {
        if (
            this?.component?.customRequestConditional &&
            !this.checkRequestCondition()
        ) {
            return;
        }

        await super.fetchData();
    }
}

export default FetchComponent;
